import React from "react"
import {Grid, Modal} from "semantic-ui-react"
import {FormattedMessage, useIntl} from "react-intl"


export const HowitworksIndividuals = () => {
    const intl = useIntl()
    return (
        <>
            <Modal.Header>
                <h1><FormattedMessage id="howitworks.individuals.header" values={{
                    individuals: <span style={{ color: "var(--creator-indi-yellow-active)", fontWeight: "bold", fontSize: 28 }}>
                        {(intl.formatMessage({id: "creator.tabs.individuals"})).toLowerCase()}:
                    </span>
                }}/></h1>
            </Modal.Header>

            <Modal.Content className="howitworks-individuals">
                <p className="centered-block"><FormattedMessage id="howitworks.individuals.about"/></p>
                {/* Required fields */}
                <p style={{ marginTop: 20, marginBottom: 0, lineHeight: 1.5 }}><FormattedMessage id="howitworks.individuals.mandatory" values={{
                    id: <span style={{ color: "coral", fontWeight: "bold", fontSize: 17 }}>
                        <FormattedMessage id="creator.column.individual.id"/>
                    </span>,
                    sex: <span style={{ color: "coral", fontWeight: "bold", fontSize: 17 }}>
                        <FormattedMessage id="creator.column.individual.sex"/>
                    </span>,
                    automatically: <span style={{ fontWeight: "bold", fontSize: 17 }}>
                        <FormattedMessage id="howitworks.individuals.automatically"/>
                    </span>,
                    break: <br/>
                }}/></p>
                <Grid columns={1}>
                    <Grid.Row style={{ paddingTop: 0 }}>
                        <Grid.Column className="col1">
                            <img src={`/assets/howitworks/${intl.locale}/individuals/individuals2.png`} alt="individuals table"/>
                        </Grid.Column>
                    </Grid.Row>
                </Grid>

                {/* Filling parents */}
                <p style={{ marginBottom: 0 }}><FormattedMessage id="howitworks.individuals.parents.required" values={{
                    parents: <span style={{ color: "var(--creator-fam-teal-active)", fontWeight: "bold", fontSize: 17 }}>
                        <FormattedMessage id="howitworks.individuals.parents"/>
                    </span>,
                    both: <span style={{ fontWeight: "bold", fontSize: 17 }}>
                        <FormattedMessage id="howitworks.individuals.parents.both"/>
                    </span>,
                }}/></p>
                <p className="centered-block"><FormattedMessage id="howitworks.individuals.parents.buttons" values={{
                    button1: <img className="parent-button" src="/assets/howitworks/one-parent.png" alt="Only one parent specified"/>,
                    button2: <img className="parent-button" src="/assets/howitworks/two-parents.png" alt="Both parents specified, but no family"/>,
                    button3: <img className="parent-button" src="/assets/howitworks/family-found.png" alt="Related family"/>,
                    break: <br/>
                }}/></p>

                {/* Disabled */}
                <p style={{ marginTop: 30 }}><FormattedMessage id="howitworks.individuals.disabled.remember" values={{
                    disabled: <span style={{ color: "lightgray", fontWeight: "bold", fontSize: 17 }}>
                        [<FormattedMessage id="howitworks.individuals.disabled"/>]
                    </span>
                }}/></p>

            </Modal.Content>
        </>
    )
}